import { colors } from '../themes/variables';

const colorParse = (color: string): string =>
  /^[a-zA-Z0-9]+$/.test(color) ? colors[color] : color;

export default colorParse;
